import { ChangeDetectorRef, Component, OnInit } from '@angular/core';
import { BaseScaffoldComponent } from '../base-scaffold/base-scaffold.component';
import { RenderedService } from '../../rendered.service';
import { IntegrationsService } from '@services/integrations.service';

@Component({
  selector: 'scaffold-integration-status',
  templateUrl: './integration-status.component.html',
  styleUrls: ['./integration-status.component.scss']
})
export class IntegrationStatusComponent extends BaseScaffoldComponent implements OnInit{



  constructor(public renderedService: RenderedService, public cdr: ChangeDetectorRef, private integrationsService: IntegrationsService) {
    super(cdr, renderedService);
  }
  integrations:any = [];
  

  ngOnInit(): void {
    this.integrationsService.getIntegrations().subscribe((integrations) => {
      console.log("integrations", integrations)
      this.integrations = integrations;
      console.log(this.integrations)
      this.update();
    });
  }

}
